module.exports = __webpack_public_path__ + "media/app/images/podcast_cta-b3a059557416924b298ddd74bf7d6ede.png";